import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

export const types = {
  classic: 'classic',
  byInterval: 'byInterval',
};

export const RowLayout = ({
  index,
  field,
  renderStart,
  renderMiddle,
  renderEnd,
  bodyDisabled,
  disabled,
  setupType,
}) => {
  return (
    <li className={styles.root}>
      <div className={styles.header}>
        {renderStart({ field, index, disabled })}
        <span className={styles.title}>Интервал {index + 1}</span>
      </div>

      <div className={styles.body}>
        <div
          className={cn(styles.cover, {
            [styles.disabled]: bodyDisabled || disabled,
          })}
        />
        <div
          className={cn(styles.col, {
            [styles.middle]: setupType === types.byInterval,
            [styles.classicMiddle]: setupType === types.classic,
          })}
        >
          {renderMiddle({ field, index })}
        </div>
        <div className={cn(styles.col, styles.end)}>
          {renderEnd({ field, index })}
        </div>
      </div>
    </li>
  );
};
